import { render, staticRenderFns } from "./LoaderSupport.vue?vue&type=template&id=734b7ee6&"
import script from "./LoaderSupport.vue?vue&type=script&lang=js&"
export * from "./LoaderSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('734b7ee6')) {
      api.createRecord('734b7ee6', component.options)
    } else {
      api.reload('734b7ee6', component.options)
    }
    module.hot.accept("./LoaderSupport.vue?vue&type=template&id=734b7ee6&", function () {
      api.rerender('734b7ee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Loaders/LoaderSupport.vue"
export default component.exports